import { HolidayActionType } from './enums';
import { type HolidayAction, type HolidayState } from './interfaces';

export const initialState: HolidayState = {
	holidaysError: null,
	holidaysLoading: true,
	holidays: []
};

export default (state = initialState, { type, payload }: HolidayAction): HolidayState => {
	switch (type) {
		case HolidayActionType.FETCH_HOLIDAYS:
			return {
				...state,
				holidaysError: null,
				holidaysLoading: true
			};

		case HolidayActionType.STORE_HOLIDAYS:
			return {
				...state,
				holidaysError: null,
				holidaysLoading: false,
				holidays: payload.events
			};

		case HolidayActionType.ERROR_HOLIDAYS:
			return {
				...state,
				holidaysLoading: false,
				holidaysError: payload.error
			};

		default:
			return state;
	}
};
